import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface InfoRow {
  label: string;
  date: string; // e.g., "25 ஜூலை, 2023"
}
interface LatestCardProps {
  title?: string;
  announcementDate?: string;
  infoRows?: InfoRow[];
  totalLabel?: string;
  totalSeats?: string | number;
  className?: string;
}

// Highlight the month word in the date using --color-highlight
const EmphasizedDate: React.FC<{
  value: string;
}> = t0 => {
  const $ = _c(13);
  const {
    value
  } = t0;
  let rest;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== value) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const match = value.match(/^(\d{1,2})\s+([^\d,]+)(.*)$/u);
      if (!match) {
        t4 = <>{value}</>;
        break bb0;
      }
      const [, day, month, t5] = match;
      rest = t5;
      t2 = day;
      t3 = " ";
      t1 = month.trim();
    }
    $[0] = value;
    $[1] = rest;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    rest = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[6] !== t1) {
    t5 = <span>{t1}</span>;
    $[6] = t1;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== rest || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <>{t2}{t3}{t5}{rest}</>;
    $[8] = rest;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
const LatestCard: React.FC<LatestCardProps> = t0 => {
  const $ = _c(24);
  const {
    title: t1,
    announcementDate: t2,
    infoRows: t3,
    totalLabel: t4,
    totalSeats: t5,
    className: t6
  } = t0;
  const title = t1 === undefined ? "\u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0BA4\u0BC7\u0BA4\u0BBF" : t1;
  const announcementDate = t2 === undefined ? "14 \u0B9C\u0BC2\u0BB2\u0BC8, 2023" : t2;
  let t7;
  if ($[0] !== t3) {
    t7 = t3 === undefined ? [{
      label: "\u0BA8\u0BBF\u0BAF\u0BAE\u0BA9\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BB5\u0BA4\u0BB1\u0BCD\u0B95\u0BBE\u0BA9 \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BA4\u0BC7\u0BA4\u0BBF",
      date: "25 \u0B9C\u0BC2\u0BB2\u0BC8, 2023"
    }, {
      label: "\u0BA8\u0BBF\u0BAF\u0BAE\u0BA9\u0BA4\u0BCD\u0BA4\u0BBF\u0BA9\u0BCD \u0BAA\u0BBE\u0BA4\u0BC1\u0B95\u0BBE\u0BAA\u0BCD\u0BAA\u0BC1",
      date: "05 \u0B9C\u0BC2\u0BA9\u0BCD, 2023"
    }, {
      label: "\u0BB5\u0BC7\u0B9F\u0BCD\u0BAA\u0BC1\u0BAE\u0BA9\u0BC1\u0BB5\u0BC8 \u0BA4\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BAA\u0BCD \u0BAA\u0BC6\u0BB1\u0BC1\u0BB5\u0BA4\u0BB1\u0BCD\u0B95\u0BBE\u0BA9 \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BA4\u0BC7\u0BA4\u0BBF",
      date: "07 \u0B9C\u0BC2\u0BA9\u0BCD, 2023"
    }, {
      label: "\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BC1\u0BAA\u0BCD\u0BAA\u0BA4\u0BBF\u0BB5\u0BC1 \u0BA4\u0BC7\u0BA4\u0BBF",
      date: "22 \u0B9C\u0BC2\u0BA9\u0BCD, 2023"
    }, {
      label: "\u0B8E\u0BA3\u0BCD\u0BA3\u0BC1\u0BAE\u0BCD \u0BA4\u0BC7\u0BA4\u0BBF (\u0BAE\u0BC1\u0B9F\u0BBF\u0BB5\u0BC1)",
      date: "25 \u0B9C\u0BC2\u0BA9\u0BCD, 2023"
    }] : t3;
    $[0] = t3;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const infoRows = t7;
  const totalLabel = t4 === undefined ? "\u0BAE\u0BCA\u0BA4\u0BCD\u0BA4 \u0B87\u0BB0\u0BC1\u0B95\u0BCD\u0B95\u0BC8\u0B95\u0BB3\u0BCD" : t4;
  const totalSeats = t5 === undefined ? "224" : t5;
  t6 === undefined ? "" : t6;
  let t8;
  if ($[2] !== title) {
    t8 = <span className="text-18-tamil-700 text-012061 leading-[1.5] line-clamp-1">{title}</span>;
    $[2] = title;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== announcementDate) {
    t9 = <span className="text-18-tamil-400 text-012061 leading-[1.5] line-clamp-1">{announcementDate}</span>;
    $[4] = announcementDate;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t8 || $[7] !== t9) {
    t10 = <div className="flex items-center justify-between gap-2 m-4 p-4 bg-EFFAFD border-b border-E6F8FD">{t8}{t9}</div>;
    $[6] = t8;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== infoRows) {
    t11 = infoRows.map(_temp);
    $[9] = infoRows;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11) {
    t12 = <div>{t11}</div>;
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== totalLabel) {
    t13 = <span className="text-18-tamil-700 text-012061 leading-[1.5] line-clamp-1">{totalLabel}</span>;
    $[13] = totalLabel;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== totalSeats) {
    t14 = <span className="text-24-tamil-700 text-012061 leading-[1.5] line-clamp-1">{totalSeats}</span>;
    $[15] = totalSeats;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t13 || $[18] !== t14) {
    t15 = <div className="flex items-center justify-between px-5 py-3 sm:px-[18px] sm:py-3.5 m-4 bg-EFFAFD border-1 border-E6F8FD">{t13}{t14}</div>;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t15) {
    t16 = <div className="w-full divider-y overflow-hidden}">{t10}{t12}{t15}</div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  return t16;
};
export default LatestCard;
function _temp(row, i) {
  return <div key={i} className="flex items-start justify-between gap-4 p-5 bg-F8F8F8 border-b border-DCDCDC"><span className="text-18-tamil-500 text-020202 leading-[1.5] line-clamp-1">{row.label}</span><span className="whitespace-nowrap text-18-tamil-400 text-020202 leading-[1.5] line-clamp-1"><EmphasizedDate value={row.date} /></span></div>;
}